import React from 'react';
import { Activity, BarChart3, Bell, BookOpen, Bot, Check, Gauge, Globe, UserCog } from 'lucide-react';

const TABS = [
  { id: 'dashboard', icon: Activity, label: 'Dashboard' },
  { id: 'analysis', icon: BarChart3, label: 'Analisi' },
  { id: 'advisor', icon: Bot, label: 'Analyst' },
  { id: 'portfolio', icon: BarChart3, label: 'Portfolio' },
  { id: 'alerts', icon: Bell, label: 'Alert' },
  { id: 'macro', icon: Globe, label: 'Macro' },
  { id: 'journal', icon: BookOpen, label: 'Journal' },
  { id: 'monitor', icon: Gauge, label: 'Monitor' },
  { id: 'account', icon: UserCog, label: 'Account' }
];

const TabBar = ({ activeTab, setActiveTab, advisorProfile, portfolioCount }) => (
  <div className="flex gap-2 md:gap-4 mb-6 border-b border-brd-primary overflow-x-auto">
    {TABS.map(tab => (
      <button
        key={tab.id}
        onClick={() => setActiveTab(tab.id)}
        className={`flex items-center gap-2 px-3 md:px-4 py-3 min-h-[44px] border-b-2 transition-all whitespace-nowrap text-sm ${
          activeTab === tab.id ? 'border-blue-500 text-blue-400' : 'border-transparent text-txt-secondary hover:text-txt-primary'
        }`}
      >
        <tab.icon size={18} />
        {tab.label}
        {tab.id === 'advisor' && advisorProfile && <Check size={13} className="text-green-400" />}
        {tab.id === 'portfolio' && portfolioCount > 0 && (
          <span className="bg-elevated text-xs px-1.5 rounded-full">{portfolioCount}</span>
        )}
      </button>
    ))}
  </div>
);

export default TabBar;
